import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getCollections } from '@/services/data-sources/get-collections';
import { Collection } from '@/types/source-types';

export const collectionsQueryKey = (orgId?: string) =>
  ['collections', orgId] as const;

interface UseGetCollectionsOptions
  extends Omit<UseQueryOptions<Collection[]>, 'queryKey' | 'queryFn'> {
  orgId?: string;
}

export const useGetCollections = (options?: UseGetCollectionsOptions) => {
  const { orgId, ...queryOptions } = options || {};

  return useQuery<Collection[]>({
    queryKey: collectionsQueryKey(orgId),
    queryFn: async () => {
      const response = await getCollections();
      if (!Array.isArray(response)) {
        throw new Error(response.detail || 'Failed to fetch collections');
      }
      return response;
    },
    staleTime: 60 * 1000,
    ...queryOptions,
    enabled: !!orgId && (queryOptions?.enabled ?? true),
  });
};
